module.exports = __webpack_public_path__ + "img/lr.673bc938.svg";